export enum UPLOAD_SECTION {
    EndorsementZip = 'EndorsementMaterials',
    EndorsementCertificate = 'EndorsementCertificate',
    AssessmentCertificate = 'AssessmentCertificate'
}
